import { Pagination } from "@mantine/core";
export const paginationProps = Pagination.extend({});
